export default function NoDataState({ title = "No data found", subtitle, icon }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      {icon ? (
        <span className="text-5xl mb-4 text-text_muted">{icon}</span>
      ) : (
        <div className="w-14 h-14 rounded-full bg-surface_alt flex items-center justify-center mb-4">
          <svg className="w-6 h-6 text-text_muted" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
              d="M9 17v-2m3 2v-4m3 4v-6M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
        </div>
      )}
      <p className="text-sm font-semibold text-text_primary">{title}</p>
      {subtitle && <p className="text-xs text-text_muted mt-1 max-w-xs">{subtitle}</p>}
    </div>
  );
}
